import { render, staticRenderFns } from "./fs1-expand.vue?vue&type=template&id=13c85304&scoped=true"
import script from "./fs1-expand.vue?vue&type=script&lang=js"
export * from "./fs1-expand.vue?vue&type=script&lang=js"
import style0 from "./fs1-expand.vue?vue&type=style&index=0&id=13c85304&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c85304",
  null
  
)

export default component.exports